
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Deux jours après votre infection – c'est-à-dire le `}<strong parentName="p">{`mercredi`}</strong>{` – vous devenez
vous-même contagieux. `}<strong parentName="p">{`Vous vous sentez bien. Les premiers symptômes de la
maladie n'apparaîtront que dans deux ou trois jours, si toutefois vous en
avez.`}</strong>{` Les membres de votre ménage ont déjà été infectés.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;